const { ready, fetchApiUrl, getParent } = require('./utilities');
const { showFollowUpsellModal } = require('./follow-upsell-modal');

ready(init);

function init() {
  const followButtons = document.querySelectorAll('.js-follow');

  followButtons.forEach((button) => {
    button.addEventListener('click', onClick);
  });
}

function guruNameFromElement(element) {
  if (element.dataset.guruName) return element.dataset.guruName;
  const title = element.querySelector('.follow__box__title');
  if (title) return title.textContent.trim();
  return null;
}

function setGuruHeaderFollowButtonStyle(element, isFollowing) {
  if (!element.closest('.follow-cta')) return;

  element.classList.add('button--big');
  element.classList.toggle('button--primary', !isFollowing);
  element.classList.toggle('button--default', isFollowing);
}

function onClick(event) {
  const element = getParent(event.target, 'js-follow');
  const wantsToFollow = !(element.dataset.isFollowing === 'true');
  const previousFollowing = element.dataset.isFollowing === 'true';

  element.classList.toggle('follow--is-following', wantsToFollow);
  element.setAttribute('data-is-following', wantsToFollow);
  setGuruHeaderFollowButtonStyle(element, wantsToFollow);

  const body = {
    guru_id: element.dataset.guruId,
    follow: element.dataset.isFollowing,
  };
  fetchApiUrl(
    '/api/v1/follow',
    wantsToFollow ? 'POST' : 'DELETE',
    JSON.stringify(body)
  ).then((response) => {
    if (!response.ok) {
      element.classList.toggle('follow--is-following', previousFollowing);
      element.setAttribute('data-is-following', previousFollowing);
      setGuruHeaderFollowButtonStyle(element, previousFollowing);
      return;
    }
    if (wantsToFollow) {
      showFollowUpsellModal({ name: guruNameFromElement(element), kind: 'guru' });
    }
  });

  const category = wantsToFollow ? 'join_group' : 'leave_group';
  gtag('event', category, {
    'group_id': element.dataset.guruId,
    'event_label': element.dataset.location
  });
}
